import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { StatsService } from "@/_services/stats.service";
import { LOCAL_STORAGE_KEYS } from "@/_models/filters/local-storage-keys";
import { StatsPolicyResult } from "@/_models/stats-policy.interface";
import { EmptyStateComponent } from "@/components/shared/empty-state/empty-state.component";
import { PolicyTypeStatsComponent } from "@/components/shared/policy-type-stats/policy-type-stats.component";
import {
    PerformanceStatsLoader,
    PerformanceTabComponent,
} from "@/components/statistics/performance-tab/performance-tab.component";

@Component({
    selector: "app-performance-policy",
    standalone: true,
    imports: [
        RouterLink,
        EmptyStateComponent,
        PerformanceTabComponent,
        PolicyTypeStatsComponent,
    ],
    templateUrl: "./performance-policy.component.html",
})
export class PerformancePolicyComponent {
    storageKey = LOCAL_STORAGE_KEYS.POLICY_FILTERS;
    loadStats: PerformanceStatsLoader<StatsPolicyResult> = (filters) =>
        this.statsService.getPolicyStats(filters);

    constructor(private statsService: StatsService) {}
}
